import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgRoomControls = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 22,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4a5 5 0 0 1 2 9.584V17a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3.416A5.001 5.001 0 0 1 9 4Zm1 12H8v1h2v-1Zm4.354-3.354 2 2-.708.708-2-2 .708-.708Zm-10.708 0 .708.708-2 2-.708-.708 2-2ZM10 14H8v1h2v-1Zm12-3-2.5 3-2.5-3h5ZM9 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM3 8.5v1H.5v-1H3ZM19.5 4 22 7h-5l2.5-3Zm-3.854-1.354.708.708-2 2-.708-.708 2-2Zm-13.292 0 2 2-.708.708-2-2 .708-.708ZM9.5.5V3h-1V.5h1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgRoomControls;